import type { DocumentNode } from '@apollo/client';
import { scroll } from '@seek/ca-myprofile-utils';
import { getOperationAST } from 'graphql';
import type { FocusEvent } from 'react';

export const isIos = (platform: string) =>
  Boolean(platform) && /iPad|iPhone|iPod/.test(platform);

export const formatDateShort = (date: Date) => {
  const d = new Date(date);

  return `${d.getDate()}/${d.getMonth() + 1}/${d
    .getFullYear()
    .toString()
    .substr(-2)}`;
};

// offset default is 27 which allows above labels to show if originally hidden when field gets focus
export const scrollIfAtTop = (evt: FocusEvent<HTMLElement>, offset = 27) => {
  const el = evt.target;
  const { top } = el.getBoundingClientRect();

  if (top <= 0) {
    scroll(el, { offset });
  }
};

export const formatMobile = (number: string) => {
  const n = number.replace(/ /g, '');

  return n.length === 10 && n.substring(0, 2) === '04'
    ? n.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3')
    : number;
};

export const isIPhone = (userAgent: string) =>
  Boolean(userAgent) && /iPhone/.test(userAgent);

export const isAndroid = (userAgent: string) =>
  Boolean(userAgent) && /Android/.test(userAgent);

export const getDeviceType = (userAgent: string) => {
  if (isIPhone(userAgent)) {
    return 'iPhone';
  }
  if (isAndroid(userAgent)) {
    return 'Android';
  }

  return 'Other';
};

export const getOperationNameFromQuery = (query: DocumentNode) => {
  const operation = getOperationAST(query);

  return operation?.name?.value ?? 'Unknown Operation Name';
};
